module.exports = __webpack_public_path__ + "static/media/watford.57a8739c.png";